import React from 'react';

export default function Pill({ className, text, icon, href, onClick }) {
  const pillJSX = (
    <>
      <span className="pill-text">{text}</span>
      {icon && <img src={icon} className="link-icon" />}
    </>
  );

  return href || onClick ? (
    <a href={href} onClick={onClick} className={`Pill is-link ${className || ''}`}>
      {pillJSX}
    </a>
  ) : (
    <span className={`Pill ${className || ''}`}>{pillJSX}</span>
  );
}
